import React, { useEffect, useState } from "react";
import { useOutletContext } from "react-router";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { APP_TITLE } from "../../../config/constant";
import { requestDashboardData } from "./dashboardPageApi";
import DashboardHero from "./dashboardComponents/DashboardHero";
import DashboardMetricsRow from "./dashboardComponents/DashboardMetricsRow";
import { DASHBOARD_HERO_CONFIG } from "./dashboardComponents/dashboardConfig";

// #region SCOPED CSS
const StyledDashboardPage = styled.div`
    &.dashboard-page-container {
        display: flex;
        flex-direction: column;
        gap: 30px;
        min-height: 100%;
        padding: 0 0 24px;
        width: 100%;
        box-sizing: border-box;
    }
`;
// #endregion

export default function DashboardPage() {
    document.title = `${APP_TITLE} - Dashboard`;

    // #region VARS
    const { MainLayoutProps } = useOutletContext();
    const userAppData = useSelector(state => state.userData?.userAppData);

    const setControlBarLeftBtns = MainLayoutProps?.setControlBarLeftBtns;
    const setControlBarCenterBtns = MainLayoutProps?.setControlBarCenterBtns;
    const setControlBarRightBtns = MainLayoutProps?.setControlBarRightBtns;
    const setFilterHeaderProperties = MainLayoutProps?.setFilterHeaderProperties;

    const userName =
        userAppData?.BOStagesAccount?.firstName ||
        localStorage.getItem("userFirstName") ||
        DASHBOARD_HERO_CONFIG.defaultUserName;
    // #endregion

    // #region STATES
    const [dashboardData, setDashboardData] = useState(null);
    const [isLoadingDashboardData, setIsLoadingDashboardData] = useState(true);
    // #endregion

    // #region EFFECTS
    useEffect(() => {
        let isMounted = true;
        const handleLoader = isLoading => {
            if (isMounted) setIsLoadingDashboardData(isLoading);
        };

        requestDashboardData({ setLoader: handleLoader }).then(data => {
            if (!isMounted || data === undefined) return;
            setDashboardData(data);
        });

        return () => {
            isMounted = false;
        };
    }, []);

    useEffect(() => {
        setupHeaders({
            setControlBarLeftBtns,
            setControlBarCenterBtns,
            setControlBarRightBtns,
            setFilterHeaderProperties
        });
    }, [setControlBarLeftBtns, setControlBarCenterBtns, setControlBarRightBtns, setFilterHeaderProperties]);
    // #endregion

    // #region RENDER
    return (
        <StyledDashboardPage className="dashboard-page-container">
            <DashboardHero userName={userName} />
            <DashboardMetricsRow dashboardData={dashboardData} isLoading={isLoadingDashboardData} />
        </StyledDashboardPage>
    );
    // #endregion
}

// #region GLOBAL METHODS
function setupHeaders(props) {
    props.setControlBarLeftBtns?.([]);
    props.setControlBarCenterBtns?.([{ to: "/dashboard", active: true, disabled: false, title: "DASHBOARD" }]);
    props.setControlBarRightBtns?.([]);

    props.setFilterHeaderProperties?.({
        visible: false,
        customContentHeader: null
    });
}
// #endregion
